module.exports = "<div #map class=\"map\">\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/here-map/here-map.component.html
// module id = ../../../../../src/app/shared/here-map/here-map.component.html
// module chunks = main